import React, { useState, useEffect } from 'react';
import { Table, Select, Button, message, Typography, Space, Popconfirm, Row, Col } from 'antd';
import { SafetyOutlined, RocketOutlined, DeleteOutlined, BoxPlotOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Text } = Typography;

const MobileRegistrationCenter = () => {
  const [data, setData] = useState({ unregistered: [], free_vpns: [] });
  const [loading, setLoading] = useState(true);
  const [selectedVpns, setSelectedVpns] = useState({});

  const fetchRegistrationData = async () => {
    try {
      const res = await axios.get('/api/box/registration-data/');
      const sortedVpns = res.data.free_vpns.sort((a, b) => 
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      );
      setData({ ...res.data, free_vpns: sortedVpns });
      setLoading(false);
    } catch (err) {
      console.error("Error loading data:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrationData();
    const interval = setInterval(fetchRegistrationData, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleRegister = async (unregId) => {
    const vpnFile = selectedVpns[unregId];
    if (!vpnFile) {
      message.warning("You must select a free VPN config first!");
      return;
    }
    try {
      await axios.post('/api/box/register-confirm/', { unreg_id: unregId, vpn_file: vpnFile });
      message.success(`Box ${vpnFile.replace('.conf', '')} successfully registered!`);
      fetchRegistrationData();
    } catch (err) {
      message.error("Registration error");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/box/unregistered-delete/${id}/`);
      message.success("Device removed.");
      fetchRegistrationData();
    } catch (err) {
      message.error("Error deleting device");
    }
  };

  const columns = [
    {
      title: 'Pending Devices',
      key: 'device',
      render: (record) => (
        <div className="m-reg-card">
          <div className="m-reg-info">
            <div className="m-reg-row">
              <Space>
                <SafetyOutlined style={{ color: '#fbbf24' }} />
                <Text strong style={{ color: 'white' }}>{record.temp_id}</Text>
              </Space>
              <span style={{ color: '#94a3b8', fontSize: '12px' }}>{record.ip}</span>
            </div>
            
            <div style={{ marginTop: '12px' }}>
              <div style={{ color: '#64748b', fontSize: '10px', marginBottom: '4px' }}>ASSIGN VPN CONFIG</div>
              <Select
                placeholder="Select free VPN"
                style={{ width: '100%' }}
                className="white-select"
                dropdownClassName="white-dropdown"
                onChange={(value) => setSelectedVpns({ ...selectedVpns, [record.id]: value })}
              >
                {data.free_vpns.map(file => (
                  <Select.Option key={file} value={file}>
                    {file.replace('.conf', '')}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="m-reg-actions">
            <Button 
              block
              type="primary"
              icon={<RocketOutlined />} 
              style={{ background: '#34d399', border: 'none', height: '35px', fontWeight: 'bold' }}
              onClick={() => handleRegister(record.id)}
            >
              REGISTER
            </Button>
            <Popconfirm
              title="Delete device?"
              onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button 
                block
                icon={<DeleteOutlined />} 
                style={{ background: '#1e293b', color: '#ef4444', border: '1px solid #334155', height: '35px' }}
              >
                DELETE
              </Button>
            </Popconfirm>
          </div>
        </div>
      )
    }
  ];

  return (
    <div>
      <Row style={{ marginBottom: '15px' }}>
        <Col span={24}>
          <div className="st-box" style={{ borderBottomColor: '#fbbf24' }}>
            <Space size="middle">
              <BoxPlotOutlined style={{ color: '#fbbf24', fontSize: '20px' }} />
              <div>
                <Space>
                  <span style={{ color: '#64748b', fontSize: '11px' }}>PENDING:</span>
                  <span style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>{data.unregistered.length}</span>
                </Space>
              </div>
            </Space>
          </div>
        </Col>
      </Row>

      <Table 
        dataSource={data.unregistered} 
        columns={columns} 
        loading={loading}
        rowKey="id"
        pagination={false}
        className="m-reg-table"
      />

      <style>{`
        .st-box { background: #1e293b; padding: 12px; border-radius: 8px; border: 1px solid #334155; border-bottom: 3px solid; display: flex; justify-content: center; align-items: center; }
        
        .m-reg-table .ant-table { background: transparent !important; }
        .m-reg-table .ant-table-thead { display: none !important; }
        .m-reg-table .ant-table-tbody > tr > td { border-bottom: 1px solid #1e293b !important; padding: 10px 0 !important; }
        .m-reg-table .ant-table-tbody > tr:hover > td { background: transparent !important; }

        .m-reg-card { 
          background: #1e293b; 
          border-radius: 8px; 
          border: 1px solid #334155; 
          padding: 12px;
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .m-reg-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .m-reg-actions {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }

        .white-select .ant-select-selector { 
          background-color: white !important; 
          color: black !important; 
          border-radius: 4px !important;
          height: 35px !important;
          display: flex;
          align-items: center;
        }
        .white-dropdown { background-color: white !important; }
        .white-dropdown .ant-select-item { color: black !important; }
      `}</style>
    </div>
  );
};

export default MobileRegistrationCenter;